import { render, staticRenderFns } from "./EmailContentEditor.vue?vue&type=template&id=71b04aa6&"
import script from "./EmailContentEditor.vue?vue&type=script&lang=js&"
export * from "./EmailContentEditor.vue?vue&type=script&lang=js&"
import style0 from "./EmailContentEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports